import { render, staticRenderFns } from "./Conclusions.vue?vue&type=template&id=1fdae20a&scoped=true&"
import script from "./Conclusions.vue?vue&type=script&lang=js&"
export * from "./Conclusions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fdae20a",
  null
  
)

export default component.exports